export const baseLineHeight = '18px';
export const boldFont = 'bold';
export const bodyFont = '"Helvetica Neue", Helvetica, Arial, sans-serif';
